type Props = {
  value: string;
  mode: any;
};

const Embedding = ({ value, mode }: Props) => {
  return <div dangerouslySetInnerHTML={{ __html: value }}></div>;
};

export { Embedding };
